import * as engine from 'store/src/store-engine'
import * as cookieStorage from 'store/storages/cookieStorage'

export const cookieStore = engine.createStore([cookieStorage])
